<template>
  <v-container grid-list-xl class="pa-0">
    <v-layout wrap v-if="page">
      <v-flex xs12>
        <m-card-list
          two-line
          title="Organisasi"
          add
          :edit="isCan('organisasi.update')"
          search
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @search="(search)=>{textSearch=search;load()}"
          @change:page="(pg)=>{cp=pg;load()}"
          @add="add"
        >
          <template v-slot:items="{props,item}">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td>
                <router-link
                  class="ok"
                  :to="{name:'organisasi.detail', params:{organisasi_id:item.kode_organisasi}}"
                >
                  <v-avatar :size="40" color="grey lighten-4">
                    <img :src="item.file_foto || 'img/organisasi-default.png'" alt="avatar" />
                  </v-avatar>
                  {{pVal(item,'nama')}}
                </router-link>
              </td>
              <td>{{pVal(item,'no_telp')}}</td>
              <td>{{pVal(item,'email')}}</td>
              <td>{{pVal(item,'fax')}}</td>
              <td>
                <m-menu left style="float:right" :items="more_menu" :object="item" />
              </td>
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{headers[0].text}}</div>
                <div class="v-data-table__mobile-row__cell">
                  <router-link
                    class="ok"
                    :to="{name:'organisasi.detail', params:{kode_organisasi:item.kode_organisasi}}"
                  >{{pVal(item,'nama')}}</router-link>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{headers[1].text}}</div>
                <div class="v-data-table__mobile-row__cell">{{pVal(item,'no_telp')}}</div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{headers[2].text}}</div>
                <div class="v-data-table__mobile-row__cell">{{pVal(item,'email')}}</div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{headers[3].text}}</div>
                <div class="v-data-table__mobile-row__cell">{{pVal(item,'fax')}}</div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mr-2">{{headers[4].text}}</div>
                <div class="v-data-table__mobile-row__cell">
                  <m-menu left style="float:right" :items="more_menu" :object="item" />
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-flex>
    </v-layout>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      page: null,
      textSearch: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Tlpn", align: "left", value: "no_telp" },
        { text: "Surel", align: "left", value: "email" },
        { text: "Fax", align: "left", value: "fax" },
        { text: "", sortable: false }
      ],
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan("organisasi.update")
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan("organisasi.destroy")
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("organisasi/get", { page: this.cp, keyword: this.textSearch })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    search() {
      this.$router.push({
        name: "home"
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
          Anda juga akan menghapus seluruh anggota di organisasi ini!
          </div>
        </div>
        
        Apakah Anda yakin akan menghapus Organisasi ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
        
      `
      )
        .then(() =>
          this.$store.dispatch("organisasi/drop", item.kode_organisasi)
        )
        .then(() => {
          this.$info("Data organisasi berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
